import React, { useEffect } from "react";

import { AssociateContentStandaloneForm } from "../../../../common/content/forms/AssociateContentStandaloneForm";
import { mapToContentAssociationFormState, useEditFileRecordContentForm } from "./hooks/useEditFileRecordContentForm";

export const EditFileRecordContentForm: React.FC = () => {
    const {
        setDefaultContentState,
        defaultContentState,
        isDefaultContentLoading,
        setIsDefaultContentLoading,
        fileRecordDetails,
        validation,
        onSubmit,
        goToFileRecordDetails
    } = useEditFileRecordContentForm();

    useEffect(() => {
        if (fileRecordDetails) {
            setDefaultContentState(mapToContentAssociationFormState(fileRecordDetails));
            setIsDefaultContentLoading(false);
        }
    }, [fileRecordDetails]);

    if (!defaultContentState) {
        return <></>;
    }

    return (
        <AssociateContentStandaloneForm
            onSubmit={onSubmit}
            onCancel={goToFileRecordDetails}
            isDefaultContentLoading={isDefaultContentLoading}
            defaultContentState={defaultContentState}
            validation={validation}
            infoMessage={
                fileRecordDetails?.isNotificationApproved
                    ? "File record notifications to Buzz are already approved. Editing content may affect the notifications."
                    : undefined
            }
        />
    );
};
